import { createTheme, ThemeProvider } from '@mui/material';
import { Toaster } from 'react-hot-toast';
import { useRoutes } from 'react-router';
import routes from './routes';
import './i18n';

function App() {
    const content = useRoutes(routes);

    const theme = createTheme({
        typography: {
            fontFamily: 'Montserrat, sans-serif !important',
            h1: {
                fontWeight: 700,
                letterSpacing: '-0.02em',
            },
            h2: {
                fontWeight: 700,
                letterSpacing: '-0.01em',
            },
            h3: {
                fontWeight: 600,
            },
            h4: {
                fontWeight: 600,
            },
            h5: {
                fontWeight: 600,
            },
            h6: {
                fontWeight: 600,
            },
            button: {
                fontWeight: 600,
                textTransform: 'none',
            },
        },
        shape: {
            borderRadius: 12,
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: '600',
                        borderRadius: 12,
                        padding: '10px 24px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            transform: 'translateY(-2px)',
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                        },
                    },
                    contained: {
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        borderRadius: 16,
                        boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
                    },
                    elevation3: {
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: 12,
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                            },
                            '&.Mui-focused': {
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                            },
                        },
                    },
                },
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                        padding: '16px',
                    },
                    head: {
                        fontWeight: 600,
                        backgroundColor: '#f8f9fa',
                        color: '#2b1f86',
                        fontSize: '0.875rem',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                    },
                },
            },
            MuiTableRow: {
                styleOverrides: {
                    root: {
                        transition: 'all 0.2s ease',
                        '&:hover': {
                            backgroundColor: 'rgba(43, 31, 134, 0.04)',
                            transform: 'scale(1.01)',
                        },
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: 16,
                        boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
                            transform: 'translateY(-4px)',
                        },
                    },
                },
            },
        },
        palette: {
            primary: {
                main: '#2b1f86',
                light: '#4531e1',
                dark: '#1a1354',
                contrastText: '#ffffff',
            },
            secondary: {
                main: '#987c64',
                light: '#b89a7f',
                dark: '#6d5a47',
            },
            background: {
                default: '#f5f7fa',
                paper: '#ffffff',
            },
            text: {
                primary: '#2d3748',
                secondary: '#718096',
            },
        },
    });

    return (
        <ThemeProvider theme={ theme }>
            <Toaster position="top-center" />
            { content }
        </ThemeProvider>
    );
}

export default App;
